import { FC } from "react";

import { getCurrencyFromCountry } from "@simplyk/common";

import { usePreviewContext } from "../../LiveFormEditor/LivePreview/context/PreviewContext";
import { GHOST_PREVIEW_OPACITY } from "../../LiveFormEditor/LivePreview/ghostPreview.constant";
import { useIsGhostPreview } from "../../LiveFormEditor/LivePreview/useIsGhostPreview";
import { useFormV2Context } from "../context/FormV2Context";

import { ThemedGenerateReceiptInfobox } from "@/features/FormV2/sharedComponents/ThemedGenerateReceiptInfobox";

export const FormV2GenerateReceiptInfobox: FC = () => {
  const { isPreview } = usePreviewContext();
  const { displayGenerateReceipt, eligibleAmountTotal, formCountry } = useFormV2Context();
  const isGhostPreview = useIsGhostPreview("FormV2TaxReceiptsBanner");

  const currency = getCurrencyFromCountry(formCountry);

  if (isPreview && !isGhostPreview) {
    return null;
  }

  if (!displayGenerateReceipt) {
    return null;
  }

  return (
    <ThemedGenerateReceiptInfobox
      eligibleAmount={eligibleAmountTotal}
      currency={currency}
      sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
    />
  );
};
